export enum VegetableType {
    Apple = "Apple",
    Beet = "Beet",
    Carrot = "Carrot",
    Corn = "Corn",
    Cucumber = "Cucumber",
    Eggplant = "Eggplant",
    Onion = "Onion",
    Orange = "Orange",
    Pear = "Pear",
    Pepper = "Pepper",
    Pumpkin = "Pumpkin",
    Radish = "Radish",
    Strawberry = "Strawberry",
    TomatoRed = "TomatoRed",
    Turnip = "Turnip",
    Watermelon = "Watermelon",
}